import * as React from 'react';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import { AllotmentRangeDataService } from '../../../allotment-range/form/allotment-range-form.data';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { AllotmentAllotmentRangeView } from './allotment-allotmentrange.view';
import { actionCreators } from "src/store/products/product-form-nav-actions";


interface PropsFromState {
	ranges?: AllotmentRangeItem[];
}

interface PropsFromDispatch {
	navigateToRange: (range: AllotmentRangeItem, title: string, text: string, key: string, allotment: AllotmentItem) => any;
	rangesLoaded: (allotment: AllotmentItem, ranges: AllotmentRangeItem[]) => any;
}

interface Props extends ComponentViewProps<AllotmentItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	toast: ToastNotifications;
	contextService: any;
	formatService: any;
	defaultLanguage: string;
}

@observer
class AllotmentAllotmentRangeController extends React.Component<Props & PropsFromDispatch & PropsFromState, any> {
	@resolve
	protected dialogService: DialogService;

	@observable
	dataService: AllotmentRangeDataService;

	protected onItemDoubleClicked = async (item: AllotmentRangeItem) => {
		const { model, defaultLanguage, navigateToRange, rangesLoaded } = this.props;
		const errors = await model.validate(false);
		if (errors.length != 0) {
			this.props.toast.showToast('Validation error!', errors.map(o => o.text), 'error');
			return;
		}

		if (item == null) {
			item = await this.dataService.add(model, defaultLanguage);
			rangesLoaded(model, [item]);
		}
		const text = `${this.props.formatService.toString("small-date", item.dateFrom)} - ${this.props.formatService.toString("small-date", item.dateTo)}`;
		navigateToRange(item, 'Allotment Range', text, 'allotmentRange', model);
	}

	protected async loadData(): Promise<void> {
		const { model, ranges, setBusy, rangesLoaded, contextService } = this.props;

		this.dataService = AllotmentRangeDataService.make(contextService, this.props.formatService);

		if (ranges == null && model.id) {
			this.dataService.addFilter('allotmentId', 'eq', this.props.model.id);
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.addFilter('isDeleted', 'eq', false);
			this.dataService.pageSize = 100;
			try {
				setBusy(true);
				const items = await this.dataService.load(query => query);
				rangesLoaded(model, items.slice());
			} catch (error) {
				this.props.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			} finally {
				setBusy(false);
			}
		} else {
			this.dataService.items = ranges;
		}
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		if (this.props.model == null || this.dataService == null) {
			return null;
		}

		const model = this.props.model;
		return (
			<AllotmentAllotmentRangeView
				mode={this.props.mode}
				model={model}
				setBusy={this.props.setBusy}
				dataService={this.dataService}
				onItemDoubleClicked={this.onItemDoubleClicked}
			/>
		);
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: ComponentViewProps<AllotmentItem>
): PropsFromState => {
	const allotment = state.otherLoadedEntities.find(e => e.entity == props.model.entity) as AllotmentItem;
	return {
		ranges: allotment
			? allotment.allotmentRanges
			: undefined,
	}
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	navigateToRange: (
		entity,
		title: string,
		text: string,
		key: string,
		allotment: AllotmentItem,
	) => dispatch(actionCreators.productFormUpNav(entity, title, text, key, {
		entity: allotment,
		key: "allotment",
		title: "Allotment",
		text: allotment.name,
	})),
	rangesLoaded: (
		allotment: AllotmentItem,
		ranges: AllotmentRangeItem[],
	) => dispatch(actionCreators.productFormRelationshipLoaded(allotment, ranges, "allotmentRanges")),
	
});

const connected = connect(mapStateToProps, mapDispatchToProps)(AllotmentAllotmentRangeController);
export { connected as AllotmentAllotmentRangeController };



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/parts/allotment-allotmentrange.controller.tsx